import React, { useState } from 'react';

const PagoMultiple = ({ 
  total, 
  pagos, 
  totalPagado, 
  restante, 
  onAgregarPago, 
  onEliminarPago,
  onClose,
  formatearNumero 
}) => {
  const [metodoPago, setMetodoPago] = useState('efectivo');
  const [monto, setMonto] = useState('');
  const [efectivoRecibido, setEfectivoRecibido] = useState('');

  const handleAgregarPago = () => {
    onAgregarPago(metodoPago, monto, efectivoRecibido);
    setMonto('');
    setEfectivoRecibido('');
    setMetodoPago('efectivo');
  };

  const calcularCambio = () => {
    if (metodoPago === 'efectivo' && efectivoRecibido !== '' && monto !== '') {
      return parseFloat(efectivoRecibido) - parseFloat(monto);
    }
    return 0;
  };

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0,0,0,0.8)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 2000
    }}>
      <div style={{
        backgroundColor: 'white',
        padding: '30px',
        borderRadius: '12px',
        width: '90%',
        maxWidth: '500px',
        maxHeight: '90vh',
        overflow: 'auto'
      }}>
        <div style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginBottom: '20px',
          borderBottom: '2px solid #f8f9fa',
          paddingBottom: '15px'
        }}>
          <h2 style={{ margin: 0, color: '#2c3e50' }}>💳 Pago Múltiple</h2>
          <button
            onClick={onClose}
            style={{
              background: 'none',
              border: 'none',
              fontSize: '24px',
              cursor: 'pointer',
              color: '#dc3545'
            }}
          >
            ✖
          </button>
        </div>

        {/* Resumen de pago */}
        <div style={{
          backgroundColor: '#f8f9fa',
          padding: '15px',
          borderRadius: '8px',
          marginBottom: '20px'
        }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '8px' }}>
            <span><strong>Total de la venta:</strong></span>
            <span style={{ color: '#2c3e50', fontWeight: 'bold' }}>
              ${formatearNumero(total)}
            </span>
          </div>
          <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '8px' }}>
            <span><strong>Total pagado:</strong></span>
            <span style={{ color: '#28a745', fontWeight: 'bold' }}>
              ${formatearNumero(totalPagado)}
            </span>
          </div>
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <span><strong>Restante por pagar:</strong></span>
            <span style={{ 
              color: restante > 0 ? '#dc3545' : '#28a745', 
              fontWeight: 'bold',
              fontSize: '1.1em'
            }}>
              ${formatearNumero(restante)}
            </span>
          </div>
        </div>

        {/* Agregar nuevo pago */}
        {restante > 0 && (
          <div style={{
            border: '1px solid #dee2e6',
            borderRadius: '8px',
            padding: '15px',
            marginBottom: '20px'
          }}>
            <h4 style={{ marginBottom: '15px', color: '#495057' }}>Agregar Método de Pago</h4>
            
            <div style={{ marginBottom: '15px' }}>
              <label style={{ display: 'block', marginBottom: '5px', fontWeight: '500' }}>
                Método de Pago:
              </label>
              <select
                value={metodoPago}
                onChange={(e) => setMetodoPago(e.target.value)}
                style={{
                  width: '100%',
                  padding: '10px',
                  borderRadius: '4px',
                  border: '1px solid #ddd',
                  fontSize: '16px'
                }}
              >
                <option value="efectivo">Efectivo</option>
                <option value="tarjeta">Tarjeta</option>
                <option value="transferencia">Transferencia</option>
              </select>
            </div>

            <div style={{ marginBottom: '15px' }}>
              <label style={{ display: 'block', marginBottom: '5px', fontWeight: '500' }}>
                Monto a pagar:
              </label>
              <input
                type="number"
                value={monto}
                onChange={(e) => {
                  // Solo procesar valores positivos
                  const valor = parseFloat(e.target.value);
                  if (!isNaN(valor) && valor >= 0) {
                    setMonto(valor);
                  } else if (e.target.value === '') {
                    // Permitir borrar el campo
                    setMonto('');
                  }
                }}
                onWheel={(e) => e.target.blur()} // Evita el scroll
                min="0" // Restringe a valores positivos
                max={restante}
                style={{
                  width: '100%',
                  padding: '10px',
                  borderRadius: '4px',
                  border: '1px solid #ddd',
                  fontSize: '16px'
                }}
                placeholder={`Máximo: $${formatearNumero(restante)}`}
              />
            </div>

            {metodoPago === 'efectivo' && (
              <div style={{ marginBottom: '15px' }}>
                <label style={{ display: 'block', marginBottom: '5px', fontWeight: '500' }}>
                  Efectivo recibido:
                </label>
                <input
                  type="number"
                  value={efectivoRecibido}
                  onChange={(e) => {
                    // Solo procesar valores positivos
                    const valor = parseFloat(e.target.value);
                    if (!isNaN(valor) && valor >= 0) {
                      setEfectivoRecibido(valor);
                    } else if (e.target.value === '') {
                      // Permitir borrar el campo
                      setEfectivoRecibido('');
                    }
                  }}
                  onWheel={(e) => e.target.blur()} // Evita el scroll
                  min="0" // Restringe a valores positivos
                  style={{
                    width: '100%',
                    padding: '10px',
                    borderRadius: '4px',
                    border: '1px solid #ddd',
                    fontSize: '16px'
                  }}
                  placeholder="Cantidad de efectivo recibida"
                />
                {efectivoRecibido && monto && (
                  <p style={{ 
                    margin: '5px 0 0 0', 
                    color: calcularCambio() >= 0 ? '#28a745' : '#dc3545',
                    fontSize: '14px'
                  }}>
                    Cambio: ${formatearNumero(calcularCambio())}
                  </p>
                )}
              </div>
            )}

            <button
              onClick={handleAgregarPago}
              disabled={!monto || (metodoPago === 'efectivo' && !efectivoRecibido)}
              style={{
                width: '100%',
                padding: '12px',
                backgroundColor: '#007bff',
                color: 'white',
                border: 'none',
                borderRadius: '4px',
                cursor: 'pointer',
                fontSize: '16px',
                opacity: (!monto || (metodoPago === 'efectivo' && !efectivoRecibido)) ? 0.6 : 1
              }}
            >
              ➕ Agregar Pago
            </button>
          </div>
        )}

        {/* Lista de pagos agregados */}
        {pagos.length > 0 && (
          <div>
            <h4 style={{ marginBottom: '15px', color: '#495057' }}>Métodos de Pago Agregados</h4>
            {pagos.map((pago) => (
              <div key={pago.id} style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                padding: '12px',
                border: '1px solid #dee2e6',
                borderRadius: '6px',
                marginBottom: '8px',
                backgroundColor: '#f8f9fa'
              }}>
                <div style={{ flex: 1 }}>
                  <div style={{ fontWeight: '500', marginBottom: '4px' }}>
                    {pago.metodoPago.charAt(0).toUpperCase() + pago.metodoPago.slice(1)}
                  </div>
                  <div style={{ fontSize: '14px', color: '#6c757d' }}>
                    Monto: ${formatearNumero(pago.monto)}
                    {pago.metodoPago === 'efectivo' && (
                      <>
                        <br />
                        Recibido: ${formatearNumero(pago.efectivoRecibido)} | 
                        Cambio: ${formatearNumero(pago.cambio)}
                      </>
                    )}
                  </div>
                </div>
                <button
                  onClick={() => onEliminarPago(pago.id)}
                  style={{
                    padding: '6px 12px',
                    backgroundColor: '#dc3545',
                    color: 'white',
                    border: 'none',
                    borderRadius: '4px',
                    cursor: 'pointer',
                    fontSize: '12px'
                  }}
                >
                  🗑️ Eliminar
                </button>
              </div>
            ))}
          </div>
        )}

        {/* Estado completo */}
        {restante === 0 && pagos.length > 0 && (
          <div style={{
            backgroundColor: '#d4edda',
            border: '1px solid #c3e6cb',
            borderRadius: '8px',
            padding: '15px',
            marginTop: '20px',
            textAlign: 'center'
          }}>
            <div style={{ color: '#155724', fontSize: '18px', fontWeight: 'bold' }}>
              ✅ Pago Completo
            </div>
            <div style={{ color: '#155724', marginTop: '5px' }}>
              Ya puedes finalizar la venta
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default PagoMultiple;
